// Gallery.js

import React, { useState } from 'react';
import './Gallery.css';

function Gallery({ currentIndex }) {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = Array.from({ length: 9 }).map((_, idx) => {
    return `/images/portfolio-${currentIndex + 1}/${idx + 1}.jpg`;
  });

  return (
    <>
      {selectedImage && (
        <div className="fullscreen" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Fullscreen preview" />
        </div>
      )}
      <div className="gallery">
        {images.map((imgSrc, idx) => (
          <img
            key={idx}
            src={imgSrc}
            alt={`Gallery ${idx}`}
            onClick={() => setSelectedImage(imgSrc)}
            className="gallery-item"
          />
        ))}
      </div>
    </>
  );
}

export default Gallery;
